module.exports = __webpack_public_path__ + "img/Openunidade.37ed9504.svg";